import { gql } from '@apollo/client'

export const GET_ADVISORIES_QUERY = gql`
  query page($path: String, $limit: Int = 10, $offset: Int = 0, $search: String) {
    advisoriesGraphql(path: $path, limit: $limit, offset: $offset, search: $search, order: "-") {
      count
      entities {
        nid
        title
        publishedAt {
          value
        }
        fieldDate {
          value
        }
        fieldUpdationDate {
          date
        }
        updationInformation
        fieldPageParagraph {
          entity {
            fieldReusableParagraphs {
              entity {
                __typename
                fieldWysiwygModContent {
                  value
                }
                fieldVideoCardModWistiaId
                bgImage {
                  entity {
                    url
                  }
                }
                bgImageMobile {
                  entity {
                    url
                  }
                }
                playButtonText
                showGradient
              }
            }
          }
        }
        path {
          alias
        }
        ShortenUrl
        entityMetatags {
          key
          value
        }
      }
    }
  }
`
